import { render } from "./GameTally.vue?vue&type=template&id=29077f96"
import script from "./GameTally.vue?vue&type=script&lang=js"
export * from "./GameTally.vue?vue&type=script&lang=js"

import "./GameTally.vue?vue&type=style&index=0&id=29077f96&lang=scss"

import exportComponent from "/Users/jburnett/Documents/TBA/hockey-scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__